// extracted by mini-css-extract-plugin
export default {"FooterPriceTitle":"printedEnhancedBomSimpleTableFooter-module_FooterPriceTitle_jDOHa"};